import LogList from "./LogList";

export default LogList;
